import styled from "styled-components";
import colours from "../../lib/colours";
import ReactSwitch from "react-switch";

const SwitchLabel = styled.label`
  display: flex;
  align-items: center;
  font-size: 16px;
  cursor: pointer;
  height: 42px;
  color: ${colours.th1l2};
  font-weight: 600;
  transition: background-color 0.2s linear, color 0.2s linear;
  &:hover {
    color: ${colours.th1};
  }
`;

const SwitchLabelSpan = styled.span`
  margin-left: 8px;
`;

interface IProps {
  id: string;
  onChange: any;
  checked: boolean;
  label?: string;
  labelChecked?: string;
  labelUnchecked?: string;
}

const Switch = ({
  id,
  onChange,
  checked,
  label,
  labelChecked,
  labelUnchecked,
}: IProps) => {
  return (
    <SwitchLabel htmlFor={id}>
      <ReactSwitch
        id={id}
        onChange={onChange}
        checked={checked}
        checkedIcon={false}
        uncheckedIcon={false}
        height={22}
        width={48}
        offColor={colours.grey2}
        onColor={colours.th2}
      />
      <SwitchLabelSpan style={{ color: checked ? colours.th1 : "unset" }}>
        {checked ? labelChecked || label : labelUnchecked || label}
      </SwitchLabelSpan>
    </SwitchLabel>
  );
};

export default Switch;
